import Morale from './Morale';

export default Morale;
